import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/routes/_authenticated/notifications";

export const Route = createFileRoute("/_authenticated/partner/notifications")({
  head: () => ({
    meta: [
      { title: "Partner alerts — Shields" },
      { name: "description", content: "Offers, work updates and Partner achievements." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: PartnerNotifications,
});

function PartnerNotifications() {
  return <NotificationsPage workspace="partner" />;
}
